import { FeatureHeader } from "@/shared/components/custom/FeatureHeader";
import { Button } from "@/shared/components/ui/button";
import { ListVideo, Plus, RefreshCw, Sparkles } from "lucide-react";


const StoryboardHeader = ({
    sceneTitle,
    displayedFramesCount,
    isFiltered,
    selectedShot,
    selectedShotFrame,
    hasFrames,
    currentSceneShots,
    showShotList,
    onInitiateFrameGeneration,
    onClearSelection,
    onRegenerateAll,
    onToggleShotList,
    onAddFrame
}: {
    sceneTitle: string;
    displayedFramesCount: number;
    isFiltered: boolean;
    selectedShot: any;
    selectedShotFrame: any;
    hasFrames: boolean;
    currentSceneShots: any[];
    showShotList: boolean;
    onInitiateFrameGeneration: (shot: any) => void;
    onClearSelection: () => void;
    onRegenerateAll: () => void;
    onToggleShotList: () => void;
    onAddFrame: () => void;
}) => {
    return (
        <FeatureHeader
            className="p-6 pb-0"
            title={sceneTitle}
            subtitle={
                <>
                    {displayedFramesCount} frame{displayedFramesCount !== 1 ? 's' : ''}
                    {isFiltered ? ' (filtered)' : ''}
                </>
            }
            actions={
                <>
                    {selectedShot && !selectedShotFrame && (
                        <Button
                            size="sm"
                            onClick={() => onInitiateFrameGeneration(selectedShot)}
                            className="animate-pulse bg-secondary text-secondary-foreground hover:bg-secondary/80"
                        >
                            <Sparkles className="mr-2 h-4 w-4" />
                            Generate Frame {currentSceneShots.findIndex(s => s.id === selectedShot.id) + 1}
                        </Button>
                    )}

                    {!selectedShot && (
                        <Button size="sm" onClick={onAddFrame}>
                            <Plus className="h-4 w-4 mr-2" />
                            Add Frame
                        </Button>
                    )}

                    {selectedShot && (
                        <Button variant="ghost" size="sm" onClick={onClearSelection}>
                            Show All Frames
                        </Button>
                    )}

                    {hasFrames && !selectedShot && (
                        <Button size="sm" onClick={onRegenerateAll}>
                            <RefreshCw className="h-4 w-4 mr-2" />
                            Regenerate
                        </Button>
                    )}

                    {!showShotList && (
                        <Button variant="outline" size="sm" onClick={onToggleShotList} className="gap-2">
                            <ListVideo className="h-4 w-4" />
                            Show Shot List
                        </Button>
                    )}
                </>
            }
        />
    )
}
export default StoryboardHeader